module.exports = __webpack_public_path__ + "static/covid-1-4d2ede5398e4e9f702c5aea1e2ad6e97.png";